export const size = {
  mobile: 480,
  tablet: 768,
  desktop: 1024,
  large: 1280,
  big: 1600,
}

export const device = {
  mobile: `(min-width: ${size.mobile}px)`,
  tablet: `(min-width: ${size.tablet}px)`,
  desktop: `(min-width: ${size.desktop}px)`,
  large: `(min-width: ${size.large}px)`,
  big: `(min-width: ${size.big}px)`,
}
